import React, { useState, useEffect, useRef } from "react";
import { useForm } from "react-hook-form";
import TableWrapper from "../../core/BaseComponents/TableWrapper/TableWrapper";
import dayjs from "dayjs";
import { Tooltip, CircularProgress } from "@mui/material";
import { MdModeEditOutline } from "react-icons/md";
import { callAPI } from "../../../axios";
import DeleteIcon from "@mui/icons-material/Delete";
import BasicModal from "../../core/BaseComponents/Modal";
import { getChainIdLS, isValidRole, ScrollToTop } from "../../../utils/utils";
import DeleteRoomTypeConfig from "./DeleteRoomTypeConfig";

function WhitelistDomain() {
  const [partnerConfigList, setPartnerConfigList] = useState([]);
  const [confirmDeletePartnerRow, setConfirmDeletePartnerRow] = useState("");
  const [confirmValidate, setConfirmValidate] = useState(false);
  const [deletePartnerPopUp, setDeletePartnerPopUp] = useState(false);
  const [editPartnerConfig, setEditPartnerConfig] = useState(false);
  const [editPartnerRowUpdate, setEditPartnerRowUpdate] = useState(false);
  const [createPartnerSuccessMsg, setCreatePartnerSuccessMsg] = useState('');
  const [editPartnerSid, setEditPartnerSid] = useState("");
  const [loader, setLoader] = useState(false);

  let validPermissionClassName = isValidRole("MASTER_CONFIG_ROOM_TYPE_MODIFY")
    ? ""
    : "btn-disable-permission";
 
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm({
    mode: 'onChange',
    defaultValues: { active: true }
  });

  const onSubmit = (data) => {
    let method = "POST";
    let url = `/domain-allowed`;
    if (editPartnerRowUpdate) {
      method = "PUT"
      url = `/domain-allowed/${editPartnerSid?.id}`;
    }
    callAPI(url, method, data )
      .then(function (response) {
        setLoader(false);
        reset({
            domain: '',
        });
        setCreatePartnerSuccessMsg(response?.message);
        PartnerListApi();
      })
      .catch(function (error) {
        setLoader(false);
        console.warn(error.response?.data?.errorMessage);
      });
  };

  const isPartnerDeletedRef = useRef({
    isPartnerDeletedModalData: null,
    userConformationModalData: null,
  });

  const deletePartnerConfigPopUpHandler = (row) => {
    setDeletePartnerPopUp(true);
    const newModalRefData = {
      isPartnerDeletedModalData: {
        row
      },
      userConformationModalData: null,
    };
    isPartnerDeletedRef.current = newModalRefData;
  }

  const deletePartnerHandler = () => {
    setConfirmValidate(true);
    if (confirmDeletePartnerRow === "") {
      return
    }

    if (confirmDeletePartnerRow === `Delete ${isPartnerDeletedRef.current?.isPartnerDeletedModalData.row.domainAllowed}`) {
      setConfirmValidate(false)
      const { row } = isPartnerDeletedRef.current?.isPartnerDeletedModalData;
      callAPI(`/domain-allowed/${row?.id}`, "DELETE")
        .then((response) => {
          let successMessage = response.message
          const newModalRefData = {
            isPartnerDeletedModalData: null,
            userConformationModalData: {
              successMessage
            },
          };
          isPartnerDeletedRef.current = newModalRefData;
          PartnerListApi();
        })
        .catch((error) => {
          setDeletePartnerPopUp(false);
          console.warn(error)
        });
    }
    reset({
        domain: '',
    });
  }

  const renderActionIcon = (row) => {
    return (
      isValidRole("MASTER_CONFIG_ROOM_TYPE_MODIFY")?<>
        {!row?.active?<><Tooltip title="Edit" arrow>
          <MdModeEditOutline
            className="edit-icon-enable"
            onClick={() => { setEditPartnerConfig(true); setEditPartnerSid(row) }}
          />
        </Tooltip>
        <Tooltip title="Delete" className="cursor-pointer" arrow>
          <DeleteIcon
            className="delete-icon-enable"
            onClick={() => {
              deletePartnerConfigPopUpHandler(row);
            }}
          />
        </Tooltip></>:
          <>
          <Tooltip title="Disable to perform actions" arrow>
            <span><MdModeEditOutline className="edit-icon-disable" /></span>
          </Tooltip>
          <Tooltip title="Disable to perform actions" arrow>
            <DeleteIcon className="delete-icon-disable"/>
        </Tooltip>
          </>
        }
      </>:<>
            <Tooltip title="Don't have permission to edit">
                <span>
                    <MdModeEditOutline className="edit-icon-disable" arrow />
                </span>
            </Tooltip>
            <Tooltip title="Don't have permission to delete">
                <DeleteIcon className="delete-icon-disable" arrow />
            </Tooltip>
        </>
    );
  };

  const columns = [
    // { field: "createdDate", headerName: "Created On", flex: 1, row: true, renderCell: (row) => <p className="mb-0">{dayjs(row.createdOn).format("DD MMM YYYY | HH:mm")}</p> },
    { field: "domainAllowed", headerName: "Domain Allowed", flex: 1 },
    {
      field: "actionCell",
      row: true,
      headerName: "Actions",
      flex: 0.5,
      renderCell: renderActionIcon,
      sortDirection: false,
      disableSortIcon: true,
    },
  ];

  const PartnerListApi = () => {
    // const apiPath = `banner/search?pageNo=${selectedPage}&recordsPerPage=${recordsPerPage}`;
    callAPI(`/domain-allowed/list`, "GET")
      .then((response) => {
        setPartnerConfigList(response?.data)
      })
      .catch((err) => console.warn(err.message));
  };

  useEffect(() => {
    PartnerListApi();
    cancelPartnerHandler()
  }, []);


  const popupCloseHandler = () => {
    setDeletePartnerPopUp(false);
  };


  useEffect(() => {
    if (editPartnerConfig) {
      getPartnerListSidHandler();
      setEditPartnerConfig(false);
    }
    ScrollToTop();
  }, [editPartnerConfig]);

  const getPartnerListSidHandler = () => {
    callAPI(`/domain-allowed/${editPartnerSid?.id}`, "GET")
      .then(function (response) {
        const payload = {
            domain: response?.domainAllowed
        };
        reset(payload);
        setEditPartnerRowUpdate(true);
      })
      .catch(function (error) {
        console.warn(error.response?.data?.errorMessage);
      });
  }

  const resetLayoutHandler = () => {
    reset();
  }

  const cancelPartnerHandler = () => {
    reset({
        domain: '',
    });
    setEditPartnerRowUpdate(false);
    setEditPartnerSid('');
    setEditPartnerConfig(false);
  }

  return (
    <div className='row config-hotel config-management-form'>
      <div className='col-12 left-column'>
        {loader && <div className="circular-progress"><CircularProgress /></div>}
        <form autoComplete="off" onSubmit={handleSubmit(onSubmit)} className="hotel-list-form">
          <div className="row">
            <div className="left-column-header">
              <p className="Roboto-Bold">{editPartnerRowUpdate ? 'Edit Domain Allowed Configuration' : 'Domain Allowed Configuration'}</p>
            </div>
            <div className="col-6">
              <div className="form-group-hotel">
                <div className="floating-label">
                  {/* <RiHotelBedFill className="new-hotel-icons" /> */}
                  <input
                    id="domain"
                    // maxLength={20}
                    placeholder=""
                    {...register("domain", {
                      required: "Domain Name Required",
                    })}
                  />
                  <label htmlFor="domain">Enter Domain Name</label>
                </div>
                {errors.domain && (
                  <small className="required">{errors.domain.message}</small>
                )}
              </div>
            </div>
          </div>
          <div className="text-end mt-3">
            <button type="button" className="clear-btn me-2" onClick={cancelPartnerHandler}>{editPartnerRowUpdate ? "Cancel" : "Clear All"}</button>
            {editPartnerRowUpdate && <>
              <button type="button" className="clear-btn me-2" onClick={resetLayoutHandler}>Reset</button>
            </>}
            <button type="submit" className={`create-btn ${validPermissionClassName} `}>{editPartnerRowUpdate ? "Update" : "Create"}</button>
          </div>
        </form>
        <div className="hotel-list">
          <p><b>Domain Allowed List</b></p>

          <TableWrapper
            data={partnerConfigList}
            columns={columns}
            noPagination={true}
            // module="partner-config"
          />
        </div>
      </div>
      {deletePartnerPopUp && <DeleteRoomTypeConfig
        deletePartnerPopUp={deletePartnerPopUp}
        isPartnerDeletedRef={isPartnerDeletedRef}
        popupCloseHandler={popupCloseHandler}
        deletePartnerHandler={deletePartnerHandler}
        setConfirmDeletePartnerRow={setConfirmDeletePartnerRow}
        confirmDeletePartnerRow={confirmDeletePartnerRow}
        confirmValidate={confirmValidate}
      />}
      <BasicModal
        popupOpen={createPartnerSuccessMsg !== ""}
        logo={"/Images/approve-qc.png"}
        bodyMessage={<p className="mt-2">{createPartnerSuccessMsg}</p>}
        footer={
          {
            secondaryButton: {
              buttonName: "OK",
              action: () => { setCreatePartnerSuccessMsg(''); setEditPartnerRowUpdate(false); PartnerListApi(); },
              buttonPrimaryCustomCss: 'cancel-btn_new'
            }
          }
        }
      />
    </div>
  )
}

export default WhitelistDomain;